const riot = require('riot');

riot.tag2('modal-project-edit', '<div class="p24 bg-overlay_secondary rounded-8" ref="modal"> <div class="f fm fbw mb32"> <div class="bold text-label_high lh15 letter-spacing-0_03em">プロジェクトを追加</div><i class="icon-close fs20 text-label_disabled cursor-pointer" onclick="{close}"></i> </div> <div ref="editor" data-is="module-project-editor"></div> </div>', '', 'class="f fh s-full bg-overlay_primary"', function(opts) {
    this.on('mount', () => {
      this.refs.editor.setup();
      this.refs.editor.on('close', () => {
        this.close();
      });
    });
});